import React, { useRef } from "react";

import {
  Container,
  Content,
  Card,
  StyledVaga,
  IconSearch,
  ContainerFilter,
  IconTimes,
} from "./styles";
import Header from "../../../components/Header";
import { useEffect } from "react";
import { useState } from "react";

import { api } from "../../../services/api";
import { mascaraCnpj } from "../../../services/utils";
import SideBarAdmin from "../../../components/SideBarAdmin";
import Confirm from "../../../components/Confirm";
import Alerts from "../../../components/Alerts";
import { format } from "date-fns";
import Input from "../../../components/Input";
import { useHistory } from "react-router";
import SpinnerLoading from "../../../components/SpinnerLoading";

function Vagas() {
  const history = useHistory();

  const headerLinks = [{ label: "Sair", to: "/" }];

  const inputSearchRef = useRef();
  const cardVagasRef = useRef();

  const [mensagem, setMensagem] = useState(undefined);
  const [loading, setLoading] = useState(true);
  const [isSearching, setIsSearching] = useState(false);
  const [empresaIdDesativar, setEmpresaIdDesativar] = useState(undefined);

  const [search, setSearch] = useState("");

  const [vagas, setVagas] = useState({
    abertas: [],
    encerradas: [],
  });

  const [vagasFiltro, setVagasFiltro] = useState(undefined);

  useEffect(() => {
    const carregarVagas = async () => {
      try {
        const response = await api.get("/admin/vagas");

        setVagas(response.data);
      } catch (error) {
        if (error.response) {
          setMensagem({
            show: true,
            titulo: "Erro",
            detalhe: error.response.data.erro,
          });
        } else {
          setMensagem({
            show: true,
            titulo: "Erro",
            detalhe: "Erro ao consultar, consulte o administrador do sistema",
          });
        }
      } finally {
        setLoading(false);
      }
    };

    carregarVagas();
  }, []);

  const handleFocusSearch = () => {
    if (!isSearching) {
      cardVagasRef.current.style.opacity = 0;
      setTimeout(() => {
        setIsSearching(true);
      }, 400);
    }
  };

  const handleBlurSearch = () => {
    if (search === "") {
      setIsSearching(false);
    }
  };

  const handleCleanSearch = () => {
    setSearch("");
    setIsSearching(false);
    setVagasFiltro();
  };

  const handleSubmitSearch = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      const response = await api.get("/admin/vagas", {
        params: {
          filtro: search,
        },
      });

      setVagasFiltro(response.data);
    } catch (error) {
      if (error.response) {
        setMensagem({
          show: true,
          titulo: "Erro",
          detalhe: error.response.data.erro,
        });
      } else {
        setMensagem({
          show: true,
          titulo: "Erro",
          detalhe: "Erro ao consultar, consulte o administrador do sistema",
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const handleDetalhe = (id) => {
    history.push(`/admin/detalhe-vaga/${id}`);
  };

  return (
    <Container>
      <Alerts
        mensagem={mensagem}
        setMensagem={setMensagem}
        tipo={mensagem?.tipo}
      />
      <SideBarAdmin></SideBarAdmin>
      <Header links={headerLinks} theme="black" />
      <Content>
        <ContainerFilter onSubmit={handleSubmitSearch}>
          {isSearching ? (
            <IconTimes onClick={handleCleanSearch} />
          ) : (
            <IconSearch onClick={() => inputSearchRef.current.focus()} />
          )}

          <input
            ref={inputSearchRef}
            placeholder="Buscar vagas por cargo, empresa ou tipo"
            onFocus={handleFocusSearch}
            onBlur={handleBlurSearch}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <button
            disabled={search === ""}
            style={{ visibility: isSearching ? "visible" : "hidden" }}
          >
            Buscar
          </button>
        </ContainerFilter>
        {loading ? (
          <SpinnerLoading />
        ) : isSearching ? (
          !vagasFiltro || search === "" ? (
            <p style={{ margin: 10 }}>Digite um filtro e clique em buscar</p>
          ) : (
            <Card ref={cardVagasRef}>
              <h1>{vagasFiltro?.length} vagas encontradas:</h1>
              {vagasFiltro?.map((v) => (
                <CardVaga vaga={v} handleDetalhe={handleDetalhe} />
              ))}
            </Card>
          )
        ) : (
          <>
            <Card ref={cardVagasRef}>
              <h1>{vagas.abertas.length} vagas abertas:</h1>
              {vagas.abertas.map((v) => (
                <CardVaga vaga={v} handleDetalhe={handleDetalhe} />
              ))}
              <hr />
              <h1 style={{ marginTop: 40 }}>
                {vagas.encerradas.length} vagas encerradas:
              </h1>
              {vagas.encerradas.map((v) => (
                <CardVaga vaga={v} handleDetalhe={handleDetalhe} />
              ))}
            </Card>
          </>
        )}
      </Content>
    </Container>
  );
}

function CardVaga({ vaga, handleDetalhe }) {
  const [showMore, setShowMore] = useState(false);

  return (
    <StyledVaga
      key={vaga.id}
      onMouseEnter={() => setShowMore(true)}
      onMouseLeave={() => setShowMore(false)}
    >
      <section>
        <h3>{vaga.cargo}</h3>
        <h4>
          <strong>{vaga.empresa}</strong> - {vaga.tipo_vaga}
        </h4>
        {vaga.data_encerramento ? (
          <p style={{ color: "red" }}>
            Encerrada em{" "}
            {format(new Date(vaga.data_encerramento), "dd/MM/yyyy")}
          </p>
        ) : (
          <p>Aberta em {format(new Date(vaga.data_criacao), "dd/MM/yyyy")}</p>
        )}{" "}
        {showMore && (
          <>
            <p>
              <span>{vaga.qtd_vinculados}</span>
              {vaga.qtd_vinculados === 1
                ? " aluno vinculado"
                : " alunos vinculados"}
            </p>
            <p>
              <span>{vaga.qtd_candidatos}</span>
              {vaga.qtd_candidatos === 1
                ? " aluno candidato"
                : " alunos candidatos"}
            </p>
            <p>
              {vaga.qtd_contratados > 0 ? (
                <>
                  <span>{vaga.qtd_contratados}</span>
                  {vaga.qtd_contratados === 1
                    ? " aluno contratado"
                    : " alunos contratados"}
                </>
              ) : (
                "Nenhum contratado"
              )}
            </p>
          </>
        )}
      </section>
      {showMore && (
        <span onClick={() => handleDetalhe(vaga.id)}>
          <p style={{ color: "green" }}>Detalhes</p>
        </span>
      )}
    </StyledVaga>
  );
}

export default Vagas;
